import React, { Component } from 'react'
import { Table, Button, Popconfirm, Icon } from 'antd'
import { withRouter } from 'react-router-dom'
import { users } from '@services/api'

class SubAgents extends Component<any> {
    render() {
        const { list, loading, updateInfo, isAdmin, agentName } = this.props

        const columns = [
            {
                title: 'שם פרטי',
                key: 'first_name',
                width: 150,
                align: 'center',
                render: (_, record) => (
                    <div>
                        {record.first_name
                            ? record.first_name
                            : !record.content
                            ? 'אין שם בהזמנה'
                            : JSON.parse(record.content).first_name}
                    </div>
                )
            },
            {
                title: 'שם משפחה',
                key: 'last_name',
                align: 'center',
                width: 150,
                render: (_, record) => (
                    <div>
                        {record.last_name
                            ? record.last_name
                            : !record.content
                            ? 'אין שם בהזמנה'
                            : JSON.parse(record.content).last_name}
                    </div>
                )
            },
            {
                title: 'טלפון',
                key: 'phone',
                align: 'center',
                width: 150,
                render: (_, record) => <div>0{record.phone}</div>
            },
            {
                title: 'מזהה',
                key: 'id',
                width: 70,
                align: 'center',
                render: (_, record) => (
                    <div
                        style={{
                            color: record.id ? 'blue' : undefined,
                            textDecoration: record.id ? 'underline' : '',
                            cursor: record.id ? 'pointer' : undefined
                        }}
                        onClick={() => {
                            record.id && window.open(`/agents/${record.id}`, '_blank')
                        }}
                    >
                        {record.id || 'אין מזהה'}
                    </div>
                )
            },
            {
                title: 'מנויים מצטברים',
                key: 'subsSold',
                width: 150,
                align: 'center',
                render: (_, record) => <div>{record.total_subs_count}</div>
            },

            {
                title: 'מנויים בחודש האחרון',
                key: 'monthly',
                width: 150,
                align: 'center',
                render: (_, record) => <div>{record.current_month_subs_count}</div>
            },
            {
                title: '',
                key: 'delete',
                width: 70,
                align: 'left',
                render: (_, record) =>
                    record.status == 'WAITING' ? (
                        <Popconfirm
                            onConfirm={() => users.cancelAgentInv({ inv_id: record.id }).then(() => updateInfo())}
                            okText="אישור"
                            cancelText="ביטול"
                            disabled={!isAdmin}
                            title={`האם לבטל הזמנה?`}
                        >
                            <Button type="primary" disabled={!isAdmin}>
                                בטל הזמנה
                            </Button>
                        </Popconfirm>
                    ) : (
                        ''
                    )
            }
        ]
        return (
            <Table
                className="center-table"
                style={{ width: '100%' }}
                rowKey="id"
                loading={loading}
                columns={columns}
                rowClassName={record => record.policy_id}
                dataSource={list}
                pagination={{
                    total: list.length,
                    pageSize: 10,
                    hideOnSinglePage: true
                }}
            />
        )
    }
}

export default withRouter(SubAgents)
